import {Component, Inject, Input, LOCALE_ID, OnDestroy} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {isEqual} from 'lodash-es';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {ButtonsTranslations} from '~shared/components/buttons/buttons-translations.service';
import {CancellationTicket, Club, Customer, InvoiceOrderStatus, InvoiceTicket, ReservationTicket} from '~core/models';
import {BankService, InvoiceService, StorageService, TixxConnectionService} from '~core/services';
import {InvoiceOrderStatusTranslationsService, TooltipTranslationService} from '~shared/translations';

/**
 * Component that displays information on customer invoices and tickets
 */
@UntilDestroy()
@Component({
  selector: 'app-customer-invoices',
  templateUrl: './customer-invoices.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class CustomerInvoicesComponent implements OnDestroy {
  @Input() public customer: Customer;
  public selectedClub: Club;
  public selectedInvoice: any;
  public invoiceOrderStatus: InvoiceOrderStatus;
  public addressDataOpened: boolean = true;
  public paymentAndShipmentOpened: boolean = true;
  public bookingDetailOpened: boolean = true;
  public ticketsOpened: boolean = true;
  public isAddressEqual: boolean;

  constructor(
    public customerService: CustomerOverViewService,
    public invoiceService: InvoiceService,
    public buttonsTranslations: ButtonsTranslations,
    public bankService: BankService,
    public tixxConnectionService: TixxConnectionService,
    private storageService: StorageService,
    public invoiceOrderStatusTranslations: InvoiceOrderStatusTranslationsService,
    public tooltipTranslations: TooltipTranslationService,
    @Inject(LOCALE_ID) public locale: any
  ) {
    this.invoiceOrderStatus = new InvoiceOrderStatus(this.invoiceOrderStatusTranslations);
    this.invoiceService.castSelectedInvoice.pipe(untilDestroyed(this))
      .subscribe((data: InvoiceTicket | ReservationTicket | CancellationTicket) => {
        this.selectedInvoice = data;
        this.isAddressEqual = this.checkEqualAddress(data);
      });
    this.storageService.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Toggles the accordion for each section
   */
  public toggleSection(section: string): void {
    switch (section) {
      case 'address':
        this.addressDataOpened = !this.addressDataOpened;
        break;
      case 'paymentAndShipment':
        this.paymentAndShipmentOpened = !this.paymentAndShipmentOpened;
        break;
      case 'bookingDetails':
        this.bookingDetailOpened = !this.bookingDetailOpened;
        break;
      case 'tickets':
        this.ticketsOpened = !this.ticketsOpened;
        break;
      default:
    }
  }

  /**
   * Checks the two addresses of invoice and determines if they are both equal
   */
  public checkEqualAddress(invoice: InvoiceTicket | ReservationTicket | CancellationTicket): boolean {
    if (!(invoice instanceof CancellationTicket)) {
      const standard = invoice.standardAddress.id;
      const delivery = invoice.deliveryAddress.id;

      return (isEqual(standard, delivery));
    }
    return false;
  }

  get isReservation(): boolean {
    return this.selectedInvoice instanceof ReservationTicket;
  }

}
